<template>
  <v-chip
    round
    small
    outline
    disabled
    class="t-payment-status"
    :color="statusLabel.color"
  >
    <span :class="`${statusLabel.color}--text`">{{ statusLabel.text }}</span>
  </v-chip>
</template>

<script>
  import { OPEN_BANKING_PAYMENT_STATUSES } from '@/models/OpenBankingPayment'

  export default {
    name: 'OpenBankingPaymentStatusLabel',
    props: {
      status: {
        required: true,
        type: String
      }
    },
    computed: {
      statusLabel () {
        switch (this.status) {
          case OPEN_BANKING_PAYMENT_STATUSES.CONFIRMED:
            return {
              text: this.status,
              color: 'green'
            }
          case OPEN_BANKING_PAYMENT_STATUSES.PROCESSING:
            return {
              text: this.status,
              color: 'orange'
            }
          case OPEN_BANKING_PAYMENT_STATUSES.FAILED:
          case OPEN_BANKING_PAYMENT_STATUSES.CANCELED:
            return {
              text: this.status,
              color: 'red'
            }
          default:
            return {
              text: this.status,
              color: 'grey'
            }
        }
      }
    }
  }
</script>
